import React, { useContext} from 'react';
import { LoginContext } from '../../../context/loginContext.js';
import 'chart.js/auto';

const Home = () => {
  const { user, logout } = useContext(LoginContext);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '10px' }}>
      <p>Inicio</p>
    </div>
  );
};

export default Home;